module.exports = __webpack_public_path__ + "media/images/ticket/matome_warning_s-c755fd5c9e47ebab2585045b3527ef08.png";